import { Control } from './control';

export class ProcessAlarm {
  constructor(
    public hash?: string,
    public description?: string,
    public pattern?: string,
    public control?: Control
  ) { }

  clone() {
    return new ProcessAlarm(
      this.hash,
      this.description,
      this.pattern,
      this.control
    );
  }

  get controlName() {
    return this.control ? this.control.name : '';
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/process-alarm.ts